module.exports = __webpack_public_path__ + "static/media/ArrowDownIconDetails.7bd1800f.svg";